import type { TaxonomyBusinessTitleEnum, Candidate } from '@axiom/validation';
import { CountryCodes, TaxonomyConst } from '@axiom/const';

const countryCodeSet = new Set([CountryCodes.HK, CountryCodes.SG]);

export const BusinessTitlesUtil = {
  const: { CONSULTANT: 'Consultant' },
  locationConversion: ({
    businessTitle,
    candidate,
  }: {
    businessTitle: TaxonomyBusinessTitleEnum | null;
    candidate?: Partial<Pick<Candidate, 'homeOffice'>>;
  }) => {
    return businessTitle === TaxonomyConst.LawyerBusinessTitle &&
      countryCodeSet.has(candidate?.homeOffice?.name)
      ? BusinessTitlesUtil.const.CONSULTANT
      : businessTitle;
  },
};
